<template>
  <div class="content">
    <div class="topimg">
      <img
        src="https://static.sprucesmart.com//picturebacbackgroundbackground1.png"
        alt=""
        style="width:100%;height:100%"
      />
    </div>
    <!-- 图片 -->
    <div class="bottom">
      <div class="box" v-for="(item, index) in imgUrl" :key="index">
        <div v-if="item.type == 2" class="pic">
          <img :src="item.img" @click="linkJump(item)" />
        </div>

        <!-- 小程序 -->
        <div
          v-else
          class="pic"
          :style="{ backgroundImage: 'url(' + item.img + ')' }"
          style="background-repeat: no-repeat;background-size:100% 100%;
box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);"
        >
          <!-- 点击打开小程序 -->
          <div
            class="wepp-btn"
            v-html="item.webApp"
            @launch="handleLaunchFn"
          ></div>
        </div>
      </div>
      <div class="text" v-show="isShow == true"></div>
      <van-button
        round
        type="primary"
        v-show="isShow == false"
        class="hasShow"
        @click="getCode"
        >点我授权</van-button
      >
    </div>
    <!-- 按钮 -->
  </div>
</template>

<script>
import {
  openWxmini,
  getActivity,
  send_code,
  click_statistics,
} from "@/common/js/auth.js";
import isWeixin from "@/common/js/wxForbidShare";
import { Toast, Button } from "vant";

export default {
  inject: ["reload"], // 引入方法
  data() {
    return {
      imgUrl: [],
      data: [],
      isShow: true,
      classify_id: "",
    };
  },
  // beforeMount() {
  //   const ua = window.navigator.userAgent.toLowerCase();
  //   if (!window.IOS_RELOADED && /iphone|ipad|ipod/.test(ua)) {
  //     window.IOS_RELOADED = true;
  //     window.location.reload();
  //   }
  // },
  async created() {
    this.stopShare();
    const oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.src = "https://res2.wx.qq.com/open/js/jweixin-1.6.0.js";
    oScript.onload = this.wxmini;
    document.body.appendChild(oScript);
    console.log("打开小程序");
    this.$nextTick(() => {
      let launchButton = document.getElementById("launch-btn");
      launchButton.addEventListener("launch", function(e) {
        console.log("success", e.detail);
      });

      launchButton.addEventListener("error", function(e) {
        console.log("fail", e.detail);
      });
    });
    let id = localStorage.getItem("openid");
    if (id) {
      // await this.openXcx();
      await this.get_imgurl();
      return;
    }
    // await this.get_Code();
    await this.get_imgurl();
  },
  mounted() {
    this.reload(); // 哪里需要在哪里调用
  },
  methods: {
    // 获取code
    async get_Code() {
      const APPID = "wxef266b2a26655ef1";
      this.code = this.$options.methods.getUrlParam("code");
      const local = window.location.href; //本地的地址
      if (this.code == null || this.code === "") {
        // 微信登录
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=spl#wechat_redirect";
        console.log("r", this.code);
        Toast("请授权后参与活动");
        this.isShow = false;
        // 传给后台
      } else {
        // 同意授权
        // await this.openXcx();
        await this.userInfo();
        await this.get_imgurl();
      }
      // return this.code;
    },
    getUrlParam(param) {
      var current_index = window.location.href.indexOf(param);
      if (current_index == -1) {
        return null;
      }
      return window.location.href.match(/code=(\S*)&state=/)[1];
    },
    // 将code传给后台
    async userInfo() {
      await send_code(this.code).then((res) => {
        console.log("获取用户信息", res);
        this.openId = res.data.openid;
        localStorage.setItem("openid", res.data.openid);
      });
    },
    // 获取图片信息
    async get_imgurl() {
      let open = localStorage.getItem("openid");
      this.classify_id = this.$route.query.classify_id;
      if (this.classify_id == undefined) {
        this.classify_id = "";
      }
      console.log("open", open);
      const getactivityres = await getActivity(open, this.classify_id);
      if (getactivityres.status == 200) {
        if (getactivityres.data.errno == 1) {
          this.get_Code();
          return;
        } else {
          for (let i in getactivityres.data) {
            if (getactivityres.data[i].type == 1) {
              //使用了反引号来将标签转成字符串，字段显示直接用${}
              getactivityres.data[
                i
              ].webApp = `<wx-open-launch-weapp id="launch-btn" @launch="handleLaunchFn" username="${getactivityres.data[i].username}" path="${getactivityres.data[i].path}">
    								<template>
    									<style>
    										.btn {
    											width: 300px;
                          height: 125px;
    										}
    									</style>
    									<div class="btn"></div>
    								</template>
    							</wx-open-launch-weapp>`;
            }
          }
          this.imgUrl = getactivityres.data;
        }
      }
      // getActivity(open).then(res => {

      // });
    },
    linkJump(item) {
      var num = 2;
      click_statistics(num).then((res) => {
        console.log("num", res);
        if (res.status == 200) {
          window.location.href = item.link;
        }
      });
    },
    handleLaunchFn(e) {
      console.log("e", e);
      var num = 1;
      click_statistics(num).then((res) => {
        console.log("num", "小程序");
        if (res.status == 200) {
          console.log("chengg");
        }
      });
    },
    stopShare() {
      if (isWeixin()) {
        // 微信环境下禁用分享
        document.addEventListener(
          "WeixinJSBridgeReady",
          function onBridgeReady() {
            // 通过下面这个API隐藏右上角按钮
            WeixinJSBridge.call("hideOptionMenu");
          }
        );
      }
    },
    async wxmini() {
      let url = window.location.href;
      // 获取密钥
      if (url.indexOf("#") > -1) {
        url = url.substring(0, url.indexOf("#"));
      }
      const openwxminires = await openWxmini({ url: url });
      console.log("分享", openwxminires);
      wx.config({
        // eslint-disable-line
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: openwxminires.data.app_id, // 必填，公众号的唯一标识
        timestamp: openwxminires.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: openwxminires.data.noncestr, // 必填，生成签名的随机串
        signature: openwxminires.data.signature, // 必填，签名
        jsApiList: ["wx-open-launch-weapp"], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });

      /* eslint-disable */
      wx.ready(function() {
        console.log("ready");
      });

      // openWxmini({ url: window.location.href }).then(res => {

      //   // let { appId, nonceStr, signature, timestamp } = res.data;

      // });
    },
    getCode() {
      this.get_Code();
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.content {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: auto;
  background: #f5f6fa;
  .topimg {
    width: 100%;
    height: 526px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 415px;
    .box {
      width: 100%;
      // height: 150px;
      //   border-radius: 20px;
      //   background: #fff;
      margin: 0 auto;
      margin-bottom: 18px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);

      //   padding: 20px;
      //   box-sizing: border-box;
      .pic {
        width: 670px;
        height: 250px;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
        margin: 0 auto;
        margin-bottom: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .text {
    position: absolute;
    width: 100%;
    margin: auto;
    color: #2c3f53;
    font-size: 18px;
    font-family: PingFang SC;
  }
  .hasShow {
    margin-top: 100px;
  }
}
</style>
